import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, reviewSlider, reviewSliderData, socialReviewList } from '../../../../Data/DashboardsData/ECommerceData'
import { ClientReviewTitle } from '../../../../Utils/Constants'
import Slider from 'react-slick'
import { H2, H5, Image, LI, P, UL } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'

export default function ReviewSlider() {
    return (
        <Col xxl={3} sm={6} className="box-col-4">
            <Card className="review-slider">
                <DropdownWithHeader headerClass='card-no-border pb-0' heading={ClientReviewTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    <div className="owl-carousel owl-theme" id="owl-carousel-dashboard">
                        <Slider {...reviewSlider}>
                            {reviewSliderData.map((item) => (
                                <div className="review" key={item.id}>
                                    <div>
                                        <Image className="img-fluid" src={dynamicImage(`dashboard-2/user/${item.image}`)} alt="" />
                                        <div className="review-content">
                                            <H2>{item.title}</H2>
                                        </div>
                                        <div className="d-flex">
                                            <H5>{item.rate}</H5>
                                            <span className="pull-right mx-2"><i className="fa fa-star font-warning" /></span>
                                            <div className="flex-grow-1">
                                                <H5>{item.number}</H5>
                                            </div>
                                        </div>
                                        <div className="social-review">
                                            <UL className='simple-list flex-row'>
                                                {socialReviewList.map((data) => (
                                                    <LI key={data.id}>
                                                        <a href={data.link} target="_blank" rel="noreferrer">
                                                            <i className={`fa fa-${data.icon}`} />
                                                        </a>
                                                    </LI>
                                                ))}
                                            </UL>
                                        </div>
                                        <P>{item.paragraph}</P>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}